import coverAsset from '../../assets/blog/covers/workload-identity.jpg';
import diagramAsset from '../../assets/blog/images/multi-cloud-iam-federation.jpg';
import { assetUrl } from '../../utils/assetUrl';

const cover = assetUrl(coverAsset);
const diagram = assetUrl(diagramAsset);

const post = {
  slug: 'passwordless-cloud-access',
  title: 'Passwordless Cloud Access with Workload Identity',
  date: '2026-08-14',
  cover,
  excerpt:
    'Replace long-lived keys with Azure Workload Identity and GCP Workload Identity Federation for pods and pipelines.',
  tags: ['Security', 'IAM', 'Azure', 'GCP'],
  content: `
Long-lived service account keys are still one of the most common ways cloud estates get burned. Workload identity removes the secret from the equation.

![Multi-cloud IAM federation with short-lived credentials across GCP and Azure](${diagram})

## The goal

Pods and CI jobs should prove who they are to Azure or GCP **without** storing a key in a vault forever.

## Azure Workload Identity

1. Create a managed identity
2. Federate it with the Kubernetes service account
3. Annotate the pod SA and drop static credentials

## GCP Workload Identity Federation

Map an external OIDC issuer (GitHub Actions, GitLab, or GKE) to a Google service account. Pipelines get short-lived tokens only.

## Practical tips

- Prefer least-privilege roles per workload, not shared “platform admin” identities
- Rotate by revoking federation bindings, not by chasing keys
- Pair with External Secrets so app config stays declarative

Passwordless access is not a silver bullet — but it removes an entire class of credential leaks from your platform.
`
};

export default post;
